import { degrees, PDFDocument, rgb, StandardFonts } from "pdf-lib";
import SignaturePad from "signature_pad";

const pdfFile = "datenueberlassungv2.pdf";
const canvas = document.querySelector("#signatureCanvas");
const signaturePad = new SignaturePad(canvas);
canvas.classList.add("signatureCanvas");

/**
 * Modifies a PDF file by adding text and a signature image to it.
 * The modified PDF is then downloaded as a file.
 *
 * @param {Event} event - The click event that triggered this function.
 */
export async function modifyPdf(event) {
  const url = pdfFile;
  const existingPdfBytes = await fetch(url).then((res) => res.arrayBuffer());

  const errorContainer = document.getElementById("error-container");

  errorContainer.innerHTML = "";

  // 2. Erstelle ein neues PDF-Dokument basierend auf der geladenen PDF
  const pdfDoc = await PDFDocument.load(existingPdfBytes);

  // Get the values from the form
  const name = document.getElementById("name").value;
  const strasse = document.getElementById("strasse").value;
  const plz = document.getElementById("plz").value;
  const ort = document.getElementById("ort").value;

  // Validate the form values
  const errors = [];
  if (name === "") {
    errors.push("Bitte geben Sie einen Namen ein.");
    document.getElementById("name").style.border = "1px solid red";
  } else {
    document.getElementById("name").style.border = "";
  }
  if (strasse === "") {
    errors.push("Bitte geben Sie eine Straße ein.");
    document.getElementById("strasse").style.border = "1px solid red";
  } else {
    document.getElementById("strasse").style.border = "";
  }
  if (plz === "") {
    errors.push("Bitte geben Sie eine Postleitzahl ein.");
    document.getElementById("plz").style.border = "1px solid red";
  } else {
    document.getElementById("plz").style.border = "";
  }
  if (ort === "") {
    errors.push("Bitte geben Sie einen Ort ein.");
    document.getElementById("ort").style.border = "1px solid red";
  } else {
    document.getElementById("ort").style.border = "";
  }

  // Validate the form values
  var plzPattern = /^[0-9]{5}$/;
  if (!plzPattern.test(plz)) {
    errors.push("Bitte geben Sie eine gültige Postleitzahl ein.");
    document.getElementById("plz").style.border = "1px solid red";
  } else {
    document.getElementById("plz").style.border = "";
  }

  // Validate the form values
  var namePattern = /^[a-zA-Z0-9\s\-]+$/;
  if (!namePattern.test(name)) {
    errors.push("Bitte geben Sie einen gültigen Namen ein.");
    document.getElementById("name").style.border = "1px solid red";
  } else {
    document.getElementById("name").style.border = "";
  }

  /* SIGNATURE IS OPTIONAL AT THIS TIME
  console.log("Sig is emtpy? " + signaturePad.isEmpty());

  if (signaturePad.isEmpty()) {
    errors.push("Bitte geben Sie eine Unterschrift ein.");
    document.getElementById("signatureCanvas").style.border = "1px solid red";
  } else {
    document.getElementById("signatureCanvas").style.border = "";
  }

  */

  if (errors.length > 0) {
    errors.forEach((error) => {
      const errorElement = document.createElement("div");
      errorElement.style.color = "red";
      errorElement.textContent = error;
      errorContainer.appendChild(errorElement);
    });
    return;
  }

  // Get the signature image as a Base64-encoded data URL.
  const signatureImage = signaturePad.toDataURL();

  // Load the signature image as a blob
  const imageUrl = signatureImage; // URL des Bildes
  const imageBytes = await fetch(imageUrl).then((res) => res.arrayBuffer());

  // Add the signature image to the last page
  const image = await pdfDoc.embedPng(imageBytes); // Bild in PNG einbetten
  const { width, height } = image.scale(0.5); // Skaliere das Bild (hier auf 50% der Originalgröße)

  // Combine the post code and city
  const plzOrt = plz + " " + ort;

  // Add the text to the first page
  const pages = pdfDoc.getPages();
  const firstPage = pages[0];
  const lastPage = pages[pages.length - 1];
  firstPage.drawText(name, {
    x: 75,
    y: 625,
    size: 12,
    color: rgb(0, 0, 0), // Schwarz
  });

  // Add the text to the first page
  firstPage.drawText(strasse, {
    x: 75,
    y: 610,
    size: 12,
    color: rgb(0, 0, 0), // Schwarz
  });

  // Add the text to the first page
  firstPage.drawText(plzOrt, {
    x: 75,
    y: 595,
    size: 12,
    color: rgb(0, 0, 0), // Schwarz
  });

  // Add the signature image to the last page
  lastPage.drawImage(image, {
    x: 350, // x-Position in Punkten
    y: 470, // y-Position in Punkten
    width: width,
    height: height,
  });

  // Save the modified PDF as a byte array
  const pdfBytes = await pdfDoc.save();

  // Replace all non-allowed characters with an empty string
  var fileNamePattern = /[^a-zA-Z0-9]/g;
  var sanitizedName = name.replace(fileNamePattern, "");

  // Create a blob and start the download
  const blob = new Blob([pdfBytes], { type: "application/pdf" });
  const link = document.createElement("a");
  link.href = URL.createObjectURL(blob);
  link.download = "datenueberlassung-" + sanitizedName + ".pdf";
  //link.click();
  //pdfViewer
  document.getElementById("pdfViewer").setAttribute("data", link.href);
}

export function clearSignature() {
  signaturePad.clear();
}
